import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';

const DimensionNameCell = observer(({model}) => {
  return (
    <div>
      {model.names.map(({dimension, value}, index) => (
        <span key={dimension}>
          {index > 0 && ' | '}
          {value || <span className='jumbo'>
            <FormattedMessage
              id='time_tracking.payroll_hours.NO_DIMENSION_VALUE'
              values={{dimensionName: dimension}}
            />
          </span>}
        </span>
      ))}
    </div>
  );
});

export default DimensionNameCell;
